// 第四版采购单编辑
<template>
    <div class="purorder-v3" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" tabindex="-1">搜索配件(F2)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1">查看配件信息(F3)</el-button>
                <el-button class="search-btn btn-primary" title="报价历史" size="small" @click.stop="showHistories()">报价历史(F4) </el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="showSalesHistories()">销售历史(F5) </el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="showPurHistories()">采购历史(F6)</el-button>
                <el-button
                    size="small"
                    class="search-btn btn-primary"
                    @click.stop="submitForm(0)"
                    v-if="(type == 2 || type == 3 || type == 0) && permission.save"
                    :disabled="stopSubmit"
                    >{{ permission.save }}(F11)</el-button
                >
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(1)" v-if="type != 1 && permission.submit" :disabled="stopSubmit"
                    >{{ permission.submit }}(F12)</el-button
                >
            </div>
            <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'">
                <div>
                    <span>售后订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="submitData.EntpCusPOId != ''">关联的采购单号：{{ orderCode }}</span>
                    <span v-if="returnCode != ''">售后单号：{{ returnCode }}</span>
                    <span>【退货总数：{{ returnCount }}】</span>
                    <span v-if="type != 1" style="font-size: 14px; color: red"
                        >（ ※ 温馨提醒：当申请退款金额为0时，为仅退货的售后 {{ type == 4 ? '，确认收款后不可修改' : '' }}）</span
                    >
                </div>
                <div class="img-e-op" @click="showMsg" v-show="!showOrderMsg">
                    <img src="../../../assets/images/down-e.png" />
                </div>
                <div class="img-e-op" @click="hideMsg" v-show="showOrderMsg">
                    <img src="../../../assets/images/up-e.png" />
                </div>
            </div>
            <div class="order-infoes" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="isOrgShow ? 5 : 4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId">
                                    <el-select
                                        v-model="submitData.WarehouseId"
                                        :disabled="dataReadonly"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        size="small"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option
                                            v-for="optionItem in warehouseList"
                                            :key="optionItem.WarehouseId"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId"
                                        >
                                            <span style="float: left">
                                                {{ optionItem.WarehouseName }}
                                            </span>
                                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择供应商" prop="EntpCusId">
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        :disabled="type == 0 || type == 1 || submitData.EntpCusPOId != '' || submitData.ApplyIsConfirm || IsDelivery || IsPartDelivery"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchCustomer"
                                        v-select-scroll-more="searchSupplierLoad"
                                        @visible-change="customerVisibleChange($event)"
                                        @change="customerChange"
                                        placeholder="选择供应商"
                                    >
                                        <el-option
                                            v-for="optionItem in customerList"
                                            :key="optionItem.EntpCusId"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                        ></el-option>
                                    </el-select>
                                    <!--售后单：财务未确认收款前，可更改供应商-->
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="售后时间" prop="ReturnTime">
                                    <el-date-picker
                                        style="width: 100%"
                                        size="small"
                                        :disabled="dataReadonly"
                                        v-model="submitData.ReturnTime"
                                        type="datetime"
                                        placeholder="选择日期时间"
                                    ></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                        <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5" v-if="isOrgShow">
                            <div class="grid-content bg-purple">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input v-if="type == 1 || dataReadonly" disabled v-model="submitData.OrgName" size="small"></el-input>
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        v-else
                                        :disabled="dataReadonly"
                                        v-model="submitData.OrgId"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        @change="orgChange($event)"
                                        @visible-change="orgVisibleChange($event)"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="optionItem in orgList"
                                            :key="optionItem.Id"
                                            :data-msg="optionItem"
                                            :label="optionItem.Name"
                                            :value="optionItem.Id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="10">
                            <div class="grid-content bg-purple">
                                <el-form-item label="售后原因" prop="Reasons">
                                    <el-input size="small" v-model="submitData.Reasons" :disabled="dataReadonly|| submitData.ApplyIsConfirm"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6" v-if="type != 3">
                            <div class="grid-content bg-purple">
                                <el-form-item :label="type == 0 ? '可退款金额' : '退款金额'">
                                    <el-input size="small" v-model="returnMoney" disabled></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6" v-if="type != 3">
                            <div class="grid-content bg-purple">
                                <el-form-item label="已退款金额">
                                    <el-input size="small" v-model="refundAmount" disabled></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="退款方式">
                                    <el-select
                                        size="small"
                                        v-model="submitData.PayType"
                                        :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                        placeholder="请选择"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="申请退款金额">
                                    <el-input-number
                                        size="small"
                                        v-model="submitData.ApplyAmount"
                                        :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                        :min="0"
                                        style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg">
                <div>
                    <span>搜索配件结果</span>
                    <el-link style="width: 120px" v-show="tableDataLength > 0" type="primary" @click="chooseAllAPsHandle">全部加入订单明细</el-link>
                    <span style="margin-left: 10px; font-size: 14px">{{ tableDataLength > 0 ? '(结果数：' + tableDataLength + ')' : '' }}</span>
                </div>
                <div class="flex">
                    <el-button icon="el-icon-refresh" type="primary" class="search-set-btn" @click="refreshResult()"></el-button>
                    <el-button icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                    <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                        <img src="../../../assets/images/down-e.png" />
                    </div>
                    <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                        <img src="../../../assets/images/up-e.png" />
                    </div>
                </div>
            </div>
            <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" style="margin-bottom: 5px">
                <ux-grid
                    ref="multipleTable"
                    height="336px"
                    style="width: 100%"
                    @cell-dblclick="dblChooseAps"
                    @table-body-scroll="tableLoad"
                    highlight-current-row
                    show-overflow
                    v-loading="searchData.page == 1 ? searchLoading : false"
                    :data="tableData"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    empty-text=""
                    @sort-change="sortChange"
                >
                    <template v-for="(col, index) in columnShowSets">
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'APCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }}</i>
                                <i v-else>{{ scope.row.APCode }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'GoodCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodCode }}</i>
                                <i v-else>{{ scope.row.GoodCode }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'GoodName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodName }}</i>
                                <i v-else>{{ scope.row.GoodName }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'AutoSerise'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <el-tooltip placement="top">
                                    <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.AutoSerise)"></div>
                                    <div class="tooltip-div">{{ row.AutoSerise }}</div>
                                </el-tooltip>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'Inventory'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <span class="inven-active">{{ submitData.WarehouseId ? row.StorageInventory : row.Inventory }}</span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'Remaining'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <span class="out-active">
                                    {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'wasteCount'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <span class="out-active">
                                    {{ row.WasteCount }}
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'SalesOutWHCout'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                                <span v-else>
                                    {{ row.SalesOutWHCout }}
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderWaitOutQuantity'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <span>
                                    <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                        row.OrderWaitOutQuantity
                                    }}</el-button>
                                    <span v-else>{{ row.OrderWaitOutQuantity }}</span>
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'POrderWaitInQuantity'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <span>
                                    <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                        row.POrderWaitInQuantity
                                    }}</el-button>
                                    <span v-else>{{ row.POrderWaitInQuantity }}</span></span
                                >
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'PlanPurchase'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                                <span v-else>{{ row.PlanPurchase }}</span>
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'IntenCount'"
                            show-overflow-tooltip
                        >
                            <template v-slot="{ row }">
                                <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                                <span v-else>
                                    <el-button v-if="row.IntenCount > 0" @click="showIntentDatas(row.EntpTempGoodsId)" type="text" style="padding: 0px">{{
                                        row.IntenCount
                                    }}</el-button>
                                    <span v-else>{{ row.IntenCount }}</span></span
                                >
                            </template>
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :field="col.ColumnCode"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            :remote-sort="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </ux-table-column>
                    </template>
                </ux-grid>
                <!-- <div class="invens-summary" v-if="isShowSummary">
                    <span class="title">各仓库库存数据：</span>
                    <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                        <span class="sname">【 {{ item.Name }} 】</span>
                        <span class="sname">库存数：</span>
                        <span class="scount"> {{ item.Count }} </span>
                    </div>
                </div> -->
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    退货商品
                    <span v-if="type != 1" style="font-size: 14px; color: red"
                        >（ ※ 温馨提醒：当不选择任何退货商品时，为仅退款的售后{{ type == 4 ? '，退货出仓的不可修改' : '' }} ）</span
                    >
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-similar" @click="resetZeroHandle" v-if="showInitNumberBtn">清空商品数量为0</el-button>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" class="pur-order-edit" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: true }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                @selection-change="handleSelectionChange"
                empty-text="该售后单无退货商品"
            >
                <ux-table-column type="checkbox" width="50" class-name="table-check" v-if="type == 0"></ux-table-column>
                <ux-table-column class-name="table-sort" type="index" title="序号" width="100"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" resizable v-if="type == 0 || type == 1">
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(false, rowIndex, 'code')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render resizable :filters="[{ data: '' }]" :filter-method="filterAPCodeMethod" v-else>
                    <template v-slot:filter="{ $panel, column }">
                        <el-input
                            type="type"
                            v-for="(option, index) in column.filters"
                            :key="index"
                            v-model="option.data"
                            @input="$panel.changeOption($event, option.data, option)"
                        />
                    </template>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(false, rowIndex, 'code')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            :ref="'code' + scope.rowIndex"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="selectLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" resizable v-if="type == 0 || type == 1">
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(false, rowIndex, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render resizable v-else>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(false, rowIndex, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="partsNameSelect"
                            style="width: 100%"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            :title="scope.row.GoodName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="selectLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" resizable v-if="type == 0 || type == 1">
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, rowIndex, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render resizable v-else>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, rowIndex, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="autoSeriseSelect"
                            :disabled="dataReadonly || scope.row.WarehousedCount > 0 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSeriseItem"
                            value-key="EntpTempGoodsId"
                            :title="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="seriseChange($event, scope.rowIndex)"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">{{ option.AutoSerise }}</div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ option.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="selectLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" v-if="type == 0" title="采购数量" width="100">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.PurchaseQuantity }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" v-if="type == 0" title="可退数量" width="110">
                    <template v-slot:header="{ column }">
                        {{ column.title }}
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">可退数量 = 已入仓数 - 已退数量</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CanReturnCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="WasteCount" v-if="type != 1" title="废品数" width="100">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.WasteCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="退货数量" width="130" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div
                            :class="[
                                'div-padding-12',
                                {
                                    'special-border': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }
                            ]"
                        >
                            <span
                                :class="{
                                    'color-red': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }"
                                >{{ row.ReturnCount }}</span
                            >
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                :ref="'count' + scope.rowIndex"
                                :min="1"
                                :max="scope.row.CanReturnCount > 0 ? scope.row.CanReturnCount : Infinity"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.ReturnCount"
                                :disabled="dataReadonly || scope.row.IsDelivery"
                                @change="priceChange"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Price" title="退单价" width="130" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 td-price">
                            <div :class="['text', { 'color-red': row.PurchasePrice === 0 }]">{{ row.PurchasePrice }}</div>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || submitData.ApplyIsConfirm"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.PurchasePrice"
                                placeholder="退单价"
                                @keyup.enter.native="addItem(true)"
                                @change="priceChange"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="退单总价" width="100">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.PurchasePrice * row.ReturnCount ? (row.PurchasePrice * row.ReturnCount).toFixed(2) : 0 }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="是否出仓" width="100" v-if="type == 1 || type == 4">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.IsDelivery ? '已出仓' : row.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Remark" title="备注" :edit-render="{ autofocus: '.el-input__inner' }" v-if="isRemarkShow">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.Remark }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="autoSeriseSelect"
                            v-if="isRemarkSelect"
                            allow-create
                            :disabled="dataReadonly|| submitData.ApplyIsConfirm"
                            size="small"
                            v-model="scope.row.Remark"
                            :popper-append-to-body="false"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="选择备注"
                            @keyup.enter.native="addItem(true)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in remarkList" :key="option.Value" :data-msg="option" :label="option.Text" :value="option.Text">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 150px">{{ option.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                        <div class="sales-input-cell" v-else>
                            <el-input
                                size="small"
                                :disabled="dataReadonly"
                                v-model="scope.row.Remark"
                                placeholder=" 请输入备注"
                                @keyup.enter.native="addItem(true)"
                            ></el-input>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type != 0 && type != 1">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button size="small" @click="delItem(rowIndex, row)" icon="el-icon-delete" v-if="!dataReadonly && row.WarehousedCount == 0"></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly && !IsDelivery && (type == 2 || type == 3 || type == 4)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex && !row.IsDelivery"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--    新增供应商    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑供应商' : '新增供应商'" :visible.sync="dialogCusVisible" width="1000px">
            <div class="dialog-content" v-if="dialogCusVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   添加仓库地址     -->
        <el-dialog
            :close-on-click-modal="false"
            title="添加仓库地址"
            :before-close="clearAddressDialog"
            :visible.sync="addressDialogVisible"
            custom-class="base-dialog"
            width="800px"
        >
            <addAddress ref="addAddress" :submitType="1" @resetData="clearAddressDialog"></addAddress>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyPurVisible" width="1200px">
            <div v-if="historyPurVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :Source="1"
                    @closeDialog="closePurHistoryDialog"
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog title="销售历史" :close-on-click-modal="false" :visible.sync="historySalesVisible" append-to-body width="1200px">
            <div v-if="historySalesVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="historySalesVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeHistoryDialog"></APQuoteHistory>
            </div>
        </el-dialog>
        <!--询价历史-->
        <el-dialog
            :close-on-click-modal="false"
            title="询价历史"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :EntpCusId="type == 8 ? submitData.EntpCusId : ''"
                    :Source="1"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 配件搜索条件弹窗 -->
        <el-dialog
            :close-on-click-modal="false"
            title="配件搜索"
            :visible.sync="searchVisible"
            width="435px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-dc-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
            @close="closeSearchDialog"
        >
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码" v-if="isExObj('APCode')">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            placeholder="请输入配件编码"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAPCodeLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="配件名称" v-if="isExObj('GoodName')">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入配件名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型" v-if="isExObj('AutoSerise')">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="互换码" v-if="isExObj('GoodCode')">
                        <el-input
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodCode"
                            placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类" v-if="isExObj('Cate')">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌" v-if="isExObj('Brand')">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数" v-if="isExObj('Inventory')">
                        <div class="flex">
                            <el-select size="small" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input ref="search_7" size="small" style="width: 90px" v-model.trim="searchData.Invent1" @focus="selectAutoHandle('search_7')"></el-input>
                            <el-input size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="提交时间" v-if="isLimitSearch">
                        <el-date-picker
                            ref="search_12"
                            v-model="dateTimes"
                            type="datetimerange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="handleChange"
                            :default-time="['00:00:00', '23:59:59']"
                            format="yyyy-MM-dd HH:mm"
                            size="small"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="尺寸" v-if="isExObj('Size')">
                        <el-input
                            ref="search_8"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Size"
                            placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="产地" v-if="isExObj('Origin')">
                        <el-autocomplete
                            ref="search_9"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            placeholder="请输入产地信息"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchOriginLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="自定义属性" v-if="isExObj('GoodDesc')">
                        <el-input
                            ref="search_10"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodDesc"
                            placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 加入清单 -->
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            width="400px"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input
                            :min="1"
                            @input="change($event)"
                            ref="confirm_0"
                            key="confirm_0"
                            v-model="rowForm._count"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input
                            :min="0"
                            @input="change($event)"
                            ref="confirm_1"
                            v-model="rowForm._price"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')"
                            type="number"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" :disabled="rowFormLoading" @click="rowConfirm">加入清单(Enter)</el-button>
                <el-button size="small" :disabled="rowFormLoading" @click="rowClose">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <!-- 自定义列 -->
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <!-- 条件设置 -->
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import customerEdit from '@/components/business/customerManage/customerEdit';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import addAddress from '@/components/common/addAddress';
import APHistory from '@/components/common/ARSaleHistory';
import APPurchaseHistory from '@/components/common/ARPurchaseHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import tableSets from '@/components/common/tableSets_v2.vue';
import jointSets from '@/components/common/jointSets.vue';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';

export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        APMsg,
        APHistory,
        APPurchaseHistory,
        APQuoteHistory,
        APInquiryHistory,
        addAddress,
        tableSets,
        jointSets,
        APNeedInDatas,
        APNeedOutDatas
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isCheckCode: true,
            returnMoney: '',
            returnCode: '',
            orderCode: '',
            returnCount: 0,
            refundAmount: 0,
            entpCusName: '',
            userMsg: userMsg,
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            tableCode: 'SearchAPForPurRe',
            isStartSearch: false,
            isStartConfirm: false,
            historySalesVisible: false,
            historyQuoteVisible: false,
            historyPurVisible: false,
            inqHistoryVisible: false,
            EntpTempGoodsIdEdit: '',
            customerEditType: 1,
            needConfirm: true,
            selectLoading: false,
            dialogCusVisible: false,
            APMsgVisible: false,
            searchVisible: false,
            jointSetVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            priceCanBeZero: false,
            addressDialogVisible: false,
            showOrderMsg: true,
            showResultMsg: false,
            saving: false,
            dataReadonly: false,
            rowVisible: false,
            rowForm: {},
            allNum: 0,
            allMoney: 0,
            loading: false,
            searchLoading: false,
            canNotEditAddr: false,
            priceCanBeEdit: false,
            isSalePriceShow: false,
            SIdList: [],
            submitData: {
                WarehouseId: '',
                WarehouseName: '',
                PReturnId: '', //退货单id
                EntpCusId: '', //供应商id
                EntpCusPOId: '', //采购单id
                ReturnTime: new Date(),
                ApplyAmount: 0,
                PayType: '',
                Reasons: '',
                SubmissionState: 0,
                DetailList: [],
                OrgId: '',
                OrgName: '',
                ShipType: ''
            },
            Limit: 30,
            isLimitSearch: false, //限制采购退货仅能开该功能商采购过的商品，并展示废品数
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            addressList: [],
            typeList: [],
            brandList: [],
            codeList: [],
            dataList: [],
            nameList: [],
            unitList: [],
            type: 1, //1 查看 2 编辑 3 新增 4 保存修改后的订单
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [
                    {
                        required: true,
                        message: '填选择供应商',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: '请填写手机号',
                        trigger: 'blur'
                    }
                ],
                ReturnTime: [
                    {
                        required: true,
                        message: '填写退货时间',
                        trigger: 'blur'
                    }
                ],
                AddressId: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                ShipType: [
                    {
                        required: true,
                        message: '填选择发货方式',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [
                    {
                        required: true,
                        message: '请选择仓库',
                        trigger: 'blur'
                    }
                ],
                WarehouseAddr: [{ required: true, message: '请填写仓库地址', trigger: 'blur' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                Reasons: [{ required: true, message: '请输入售后原因', trigger: 'blur' }]
            },
            permission: {},
            warehouseList: [], //仓库地址
            changeCodeConfig: false,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值 - 改功能暂时注释 2021-7-23
            initNumber: 1,
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            addAPParams: {},
            isInvenShow: false,
            isOrgShow: false, //开单部门
            isLastOrg: false,
            oldOrgId: '',
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            isRemarkShow: false,
            isForceRemark: false,
            orgList: [],
            tableData: [],
            selectedList: [],
            tableDataLength: 0,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '1',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                StartDate: '',
                EndDate: ''
            },
            columnShowSets: [],
            tableSetsVisible: false,
            separator: '',
            dateTimes: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            timer: null, //保存setTimeout定时器对象
            optionLoading: false,
            seriesList: [],
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            rowFormLoading: false,
            isShowSummary: false,
            // summaryList: [],
            isBrandSort:false,
            isOriginSort: false,
            nameCallBack: '',
            apCodeCallBack: '',
            originCallBack: '',
            autoCallBack: '',
            isUseSE: false,
            isShowBrand: false, //是否显示品牌
            startAddChace: false,
            stopSubmit: false,
            IsDelivery: false, //订单是否出库
            IsPartDelivery: false, //部分出仓
            cgwdtksqConfig: false,
            isRemarkSelect: false,
            remarkList: [],
            submitStorageName:'purReturnOrder',
            dataStorageName:'purReturnOrder_dataList',
        };
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        },
        dataList: {
            deep: 'true',
            handler() {
                this.returnCount = 0;
                for (var j = 0; j < this.dataList.length; j++) {
                    this.returnCount = parseInt(this.dataList[j].ReturnCount) + this.returnCount;
                }
                // 跟单售后触发
                if (this.type * 1 === 0) {
                    this.totalPriceSum();
                }
                if (this.type * 1 != 1 && this.startAddChace) {
                    this.addPageChace();
                }
            }
        },
        submitData: {
            handler() {
                if (this.type * 1 != 1 && this.startAddChace) this.addPageChace();
            },
            deep: true
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSendWay();
        this.getPay();
        this.getSIdList();
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
        this.type = Number(this.$route.query.type);

        this.$util.getSysConfig('cgshxz').then(data => {
            this.isLimitSearch = data && data.Result;
        });
    },
    mounted() {
        this.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            return this.infiniteListHeight - 48;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 7, 8].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 是否展示：清空商品数量为0按钮
        showInitNumberBtn() {
            return this.initNumber == 0 && ![1, 4, 5, 6].includes(this.type * 1);
        }
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            if (key === 107) {
                //+
                if (!that.searchVisible) that.addItem(false);
                return;
            }
            if (key == 112) {
                //F1
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                //F2
                e.preventDefault();
                //在订转采购的限制
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            if (key == 114) {
                //F3
                if (that.type == 4) return;
                e.preventDefault();
                if (!that.APMsgVisible) that.showAPMsgDialog();
                return;
            }
            if (key == 115) {
                e.preventDefault();
                if (!that.historyQuoteVisible && !that.searchVisible) that.showHistories();
                else if (that.searchVisible) {
                    that.vinSearch();
                }
                return;
            }
            if (key == 116) {
                e.preventDefault();
                if (!that.historyVisible) that.showHistoryDialog();
                return;
            }
            if (key == 117) {
                e.preventDefault();
                if (!that.historyPurVisible) that.showPurHistories();
                return;
            }
            if (key == 122) {
                //F11
                if (!that.permission.save && that.type == 4) return;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    that.submitForm(0);
                    return;
                }
                return;
            }
            if (key == 123) {
                //F12
                if (!that.permission.submit) return;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    that.submitForm(1);
                    return;
                }
                return;
            }
            if (key === 13) {
                //Enter
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading) {
                                that.rowConfirm();
                            }
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        (!that.$refs.search_5 || (that.$refs.search_5 && !that.$refs.search_5.visible)) &&
                        (!that.$refs.search_6 || (that.$refs.search_6 && !that.$refs.search_6.visible)) &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }

                return;
            }
            if (key === 27) {
                that.canSearch = true;
                if (
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) ||
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_9 && that.$refs.search_9.suggestionVisible)
                ) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_9 && that.$refs.search_9.suggestionVisible) that.$refs.search_9.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                //right arrow
                e.preventDefault();
                if (that.searchVisible && !that.rowVisible) {
                    that.searchVisible = false;
                    that.isStartSearch = false;
                } else if (!that.searchVisible && that.rowVisible) {
                    that.rowVisible = false;
                    that.isStartConfirm = false;
                }
                if (that.APMsgVisible) that.APMsgVisible = false;
                if (that.needInDataVisible) that.needInDataVisible = false;
                if (that.needOutDataVisible) that.needOutDataVisible = false;
                return;
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historySalesVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        var cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    // that.getInvenDatas(that.currentRow);
                                }
                            });
                            if (that.dataindex > that.tableData.length - 10 && !that.searchLoading && that.dataindex < that.tableDataLength - 14) that.downKeyToLoad();
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }

                                that.searchIndex += 1;
                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex < 10) {
                                    that.searchIndex += 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    // that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }

                                that.searchIndex -= 1;
                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex > 0) {
                                    that.searchIndex -= 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        goback() {
            this.$router.push('/purchaseManage/purchasesReturns');
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'xsspjgwl',
                    'kdyjz',
                    'spmrsl',
                    'lybsdr',
                    'syztsj',
                    'kdbjsd',
                    'ddhhm',
                    'ddkcs',
                    'xskdxskdbm',
                    'kdbmmrsycxz',
                    'kdspcd',
                    'kdspgg',
                    'xskdmrcdpx',
                    'kdmrpppx',
                    'xgcgjg',
                    'cgkdzssjl',
                    'kcspssyq',
                    'kdxspp',
                    'cgwdtksq',
                    'xzqpbmdwyx',
                    'cgthspzsbz',
                    'cgthspxzbz'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'xsspjgwl': //获取采购价可为零配置
                                    this.priceCanBeZero = result;
                                    break;
                                case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'spmrsl': // 功能配置：获取客户配置的初始数量值
                                    if (result && !isNaN(rValue)) {
                                        this.initNumber = rValue;
                                        if (this.dataList && this.dataList.length > 0) {
                                            let lastData = this.dataList[this.dataList.length - 1];
                                            if (!lastData.EntpTempGoodsId) {
                                                lastData.Count = this.initNumber;
                                            }
                                        }
                                    }
                                    break;
                                case 'lybsdr': // 获取留余的计算方式
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'kdbjsd': // 获取权限：选择商品完成回车或点加号后触发锁定不可修改
                                    this.hasLock = !result;
                                    break;
                                case 'cgwdtksq': // 采购无单售后价格默认赋值商品退货价的合计
                                    this.cgwdtksqConfig = result;
                                    break;
                                case 'ddhhm': // 是否展示互换码
                                    this.changeCodeConfig = result;
                                    break;
                                case 'ddkcs':
                                    this.isInvenShow = result;
                                    break;
                                case 'xskdxskdbm': //开单部门
                                    this.isOrgShow = result;
                                    break;
                                case 'kdbmmrsycxz': //赋值上次开单部门
                                    this.isLastOrg = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xskdmrcdpx': //是否默认产地排序
                                    this.isOriginSort = result;
                                    break;   
                                case 'kdmrpppx': //是否默认品牌排序
                                    this.isBrandSort = result;
                                    break;
                                case 'xgcgjg': //未完成前价格是否可以修改
                                    this.priceCanBeEdit = result;
                                    break;
                                case 'cgkdzssjl': //销售价（入仓时修改销售价）
                                    this.isSalePriceShow = result;
                                    break;
                                case 'kcspssyq': //使用搜索引擎
                                    this.isUseSE = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'cgthspzsbz': //采购备注是否开启下拉
                                    this.isRemarkShow = result;
                                    break;
                                case 'cgthspxzbz': //采购备注是否开启下拉
                                    this.isRemarkSelect = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        init() {
            this.permission = this.$util.getPermission('purchasesReturns');
            this.submitData.PReturnId = this.$route.query.PReturnId;
            this.submitData.EntpCusPOId = this.$route.query.id;

            if(this.type==3){
                this.submitStorageName=this.submitStorageName+'_add';
                this.dataStorageName=this.dataStorageName+'_add';                
            }else if(this.type==0){
                this.submitStorageName=this.submitStorageName+'_add_p';
                this.dataStorageName=this.dataStorageName+'_add_p';                
            }
            let orderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            switch (this.type) {
                case 1:
                    this.pageTitle = '查看采购售后单';
                    this.dataReadonly = true;
                    this.needConfirm = false;
                    this.getConfigByCodes().then(() => {
                        if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                        this.getReturnOrderDetail(1);
                    });
                    break;
                case 2:
                    this.pageTitle = '编辑采购售后单';
                    this.getConfigByCodes().then(() => {
                        if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                        if (orderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                        } else {
                            this.getReturnOrderDetail(2, true);
                        }
                    });
                    break;
                case 3:
                    // 从采购退货页面点击新增采购退货
                    this.pageTitle = '新增采购售后单';
                    this.getConfigByCodes().then(() => {
                        if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                        if (orderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        } else {
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                        if (!this.submitData.EntpCusId) {
                            this.$util.warningMsg('请先选供应商');
                            return;
                        }
                    });
                    break;
                case 4:
                    this.pageTitle = '修改采购售后单';
                    this.getConfigByCodes().then(() => {
                        if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                        if (orderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                        } else {
                            this.getReturnOrderDetail(4, true);
                        }
                    });

                    break;
                case 0:
                    // 从采购订单点击
                    this.pageTitle = '新增采购售后单';
                    this.getConfigByCodes().then(() => {
                        if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();

                        if (orderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        } else {
                            this.getReturnOrderDetail(0, true).then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        }
                        if (!this.submitData.EntpCusId) {
                            this.$util.warningMsg('请先选供应商');
                            return;
                        }
                    });
                    break;
                default:
                    break;
            }
            if (!localStorage) this.startAddChace = true;
        },
        // 清空数量为零的Row
        resetZeroHandle() {
            this.dataList = this.dataList.filter(f => f.Count * 1 > 0);
            this.$util.successMsg('已清空商品数量为 0 的商品');
        },
        change(e) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].Count = that.rowForm._count;
                    that.dataList[fIdx].Price = that.rowForm._price;
                }
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请先选供应商');
                return;
            }
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        showResultFunc() {
            this.showResultMsg = true;
        },
        hideResultFunc() {
            this.showResultMsg = false;
        },
        hideMsg() {
            this.showOrderMsg = false;
            if (this.$refs.cusselect) this.$refs.cusselect.blur();
        },
        showMsg() {
            this.showOrderMsg = true;
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            } else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 数量或者价格变动
        priceChange(changeApply = true) {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].ReturnCount);
                _allMoney += Number(DetailList[i].ReturnCount * DetailList[i].PurchasePrice ? (DetailList[i].ReturnCount * DetailList[i].PurchasePrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
            if (this.cgwdtksqConfig) {
                if (typeof changeApply === 'number' || (typeof changeApply === 'boolean' && changeApply)) {
                    this.$nextTick(() => {
                        this.submitData.ApplyAmount = _allMoney.toFixed(2);
                    });
                }
            }
        },
        closeDialog(edit) {
            this.dialogCusVisible = false;
            this.tableSetsVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogCusVisible = true;
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: this.type == 7 ? '/api/EntpPurchaseOrder/GetEntpPurOrderAfterSubmit' : '/api/EntpPurchaseOrder/GetEntpPurOrderDetails',
                    data: {
                        EntpCusPOId: this.id,
                        Type: this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == data.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: data.SId,
                            EmployeeName: data.SName
                        });
                    }
                    if (this.isOrgShow && res.data.OrgId) {
                        this.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }
                    this.submitData = data;

                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].Price ? DetailList[i].Count * DetailList[i].Price : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }
                    // 判断是否可编辑
                    if (this.type != 2 && this.type != 3 && this.type != 7) this.dataReadonly = true;

                    this.allMoney = _allMoney.toFixed(2);
                    this.allNum = _allNum;
                    this.dataList = DetailList;

                    this.$set(this.submitData, 'WarehouseAddr', data.ShipAddr);
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                        if (!this.submitData.WarehouseAddr)
                            //先取订单已保存的地址，若是没有再取仓库地址
                            this.$set(this.submitData, 'WarehouseAddr', data.Warehouse.Address);

                        this.submitData.ShipAddr = data.ShipAddr; //只用于条件判断，无其他用途
                    }
                });
        },
        // 获取采购售后单详情
        getReturnOrderDetail(type, hasLock) {
            return new Promise(resolve => {
                let that = this;
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: '/api/EntpPurReturnOrder/GetPurchaseReturnOrderDetail',
                        data: {
                            Type: type,
                            EntpCusPOId: that.submitData.EntpCusPOId,
                            PReturnId: that.submitData.PReturnId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        let DetailList = data.DetailList;
                        let i = that.customerList.findIndex(item => {
                            if (item.EntpCusId == res.data.EntpCusId) {
                                return true;
                            }
                        });
                        if (i == -1) {
                            that.customerList.push({
                                EntpCusId: res.data.EntpCusId,
                                EntpCusName: res.data.EntpCusName
                            });
                            that.entpCusName = res.data.EntpCusName;
                        }

                        if (res.data.WarehouseId) {
                            let iw = that.warehouseList.findIndex(item => {
                                if (item.WarehouseId == res.data.WarehouseId) {
                                    return true;
                                }
                            });
                            if (iw == -1) {
                                that.warehouseList.push({
                                    WarehouseId: res.data.WarehouseId,
                                    WarehouseName: res.data.WarehouseName,
                                    Type: res.data.WarehouseType
                                });
                            }
                        }
                        let ip = that.payWayList.findIndex(item => {
                            if (item.Value == res.data.PayType) {
                                return true;
                            }
                        });
                        if (ip == -1) {
                            that.payWayList.push({
                                Value: res.data.PayType,
                                Text: res.data.PayTypeName
                            });
                        }
                        if (that.isOrgShow && res.data.OrgId) {
                            that.oldOrgId = res.data.OrgId;
                            that.orgList.push({ Id: res.data.OrgId, Name: res.data.OrgName });
                        }

                        DetailList.forEach(ele => {
                            (ele.hasLock = hasLock), (ele.AutoSeriseItem = ele.AutoSerise);
                        });

                        that.submitData = data;
                        that.returnMoney = data.Paid;
                        that.refundAmount = data.RefundAmount;
                        that.returnCode = data.ReturnCode;
                        that.orderCode = data.OrderCode;
                        that.dataList = DetailList;
                        that.IsDelivery = data.IsDelivery;
                        that.IsPartDelivery = data.IsPartDelivery;
                        for (var j = 0; j < that.dataList.length; j++) {
                            that.returnCount = parseInt(that.dataList[j].ReturnCount) + that.returnCount;
                        }
                        // if (type == 2 || that.type == 4) {
                        //     if (!that.dataList || that.dataList.length == 0) this.addItem();
                        // }
                        this.$nextTick(() => {
                            that.priceChange(false);
                        });
                    })
                    .finally(() => {
                        that.loading = false;
                        resolve();
                    });
            });
        },
        // 提交采购售后单
        submitForm(SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = [];
                    if (this.type == 0) _dataList = this.selectedList;
                    else {
                        if (this.dataList.length > 0) {
                            this.dataList.forEach(item => {
                                if (item.EntpTempGoodsId) _dataList.push(item);
                            });
                        }
                    }

                    if (_dataList.length == 0 && this.submitData.ApplyAmount == 0) {
                        this.$util.warningMsg('售后必须至少具备退货或退款其中一项');
                        return;
                    }

                    if (this.submitData.ApplyAmount > 0) {
                        if (!this.submitData.PayType) {
                            this.$util.warningMsg('当申请退款时，退款方式必须选择哟');
                            return;
                        }
                    }

                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }

                        if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
                            this.$util.warningMsg('请填写正确的退货数量');
                            return;
                        }
                        if (!_dataList[i].IsDelivery && _dataList[i].CanReturnCount && _dataList[i].ReturnCount > _dataList[i].CanReturnCount) {
                            this.$util.warningMsg('可退货数量不足');
                            return;
                        }
                        if (this.isRemarkShow && this.isForceRemark && !_dataList[i].Remark) {
                            this.$util.warningMsg('请填写备注');
                            return;
                        }
                        if (!this.isRemarkShow && _dataList[i].Remark) {
                            var index = this.remarkList.findIndex(x => x.Text == _dataList[i].Remark);
                            if (index >= 0) {
                                _dataList[i].RemarkId = this.remarkList[index].Id;
                            } else {
                                _dataList[i].RemarkId = '';
                            }
                        } else {
                            _dataList[i].RemarkId = '';
                        }
                    }
                    this.submitData.SubmissionState = SubmissionState;
                    this.submitData.DetailList = _dataList;
                    if (this.stopSubmit) {
                        return;
                    }
                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;
                                this.submitFormAgain(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submitFormAgain(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        //从缓存中读取上次开单的部门
        getLastOrderOrgId() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                if (this.orgList.length == 0) {
                    this.$util.getParentOrgs().then(data => {
                        this.orgList = data;
                        this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                            if (result) {
                                let orgdata = JSON.parse(result);
                                if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                    this.submitData.OrgId = orgdata.OrgId;
                                    this.submitData.OrgName = orgdata.OrgName;
                                }
                            }
                            resolve();
                        });
                    });
                } else
                    this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                        if (result) {
                            let orgdata = JSON.parse(result);
                            if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                this.submitData.OrgId = orgdata.OrgId;
                                this.submitData.OrgName = orgdata.OrgName;
                            }
                        }
                        resolve();
                    });
            });
        },
        submitFormAgain(SubmissionState) {
            let that = this;
            that.loading = true;
            that.stopSubmit = true;
            let type = that.type;
            let url = '';
            if (type == 4) {
                url = '/api/EntpPurReturnOrder/SavePurReturnOrderAfterSubmit_V3';
            } else if (type == 3 || !that.submitData.EntpCusPOId) {
                url = '/api/EntpPurReturnOrder/SaveEntpPurDirectReturnOrder_V3';
            } else {
                url = '/api/EntpPurReturnOrder/SaveEntpPurReturnOrder_V3';
            }
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData,
                    hideLoading: true
                })
                .then(res => {
                    this.needConfirm = false;
                    if (SubmissionState) {
                        this.$util.successMsg('提交采购售后单成功');
                    } else {
                        this.$util.successMsg('保存采购售后单成功');
                    }

                    this.removePageChace();
                    this.$store.commit('updateNeedRefresh', true);

                    if (type == 0 || type == 3) {
                        that.$store.commit('updateOrderList', { Id: res.data, IsAdd: true });
                    } else {
                        that.$store.commit('updateOrderList', { Id: that.submitData.PReturnId, IsAdd: false });
                    }
                    //添加默认部门
                    if (
                        that.isOrgShow &&
                        that.isLastOrg &&
                        that.submitData.OrgId &&
                        (that.type == 0 || that.type == 3 || ((that.type == 2 || that.type == 4) && that.oldOrgId != that.submitData.OrgId))
                    ) {
                        var og = {
                            OrgId: that.submitData.OrgId,
                            OrgName: that.submitData.OrgName
                        };
                        let CacheList = [];
                        CacheList.push({ CacheKey: 'LastOrderOrg', CacheValue: JSON.stringify(og), CacheType: '1' });
                        that.$util.SetEntpCache(CacheList);
                    }
                    setTimeout(() => {
                        this.$router.push('/purchaseManage/purchasesReturns');
                    }, 2000);
                })
                .catch(() => {
                    this.stopSubmit = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].ReturnCount = Number(row[index].ReturnCount) + Number(item.ReturnCount);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].ReturnCount = Number(row[index].ReturnCount) + Number(item.ReturnCount);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index, item) {
            let that = this;
            that.dataList.splice(index, 1);
            that.priceChange();
            that.addPageChace(); //添加销售订单缓存

            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = false;
            }
            that.returnCount = 0;
            for (var j = 0; j < that.dataList.length; j++) {
                that.returnCount = parseInt(that.dataList[j].ReturnCount) + that.returnCount;
            }
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }

                if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
                    this.$util.warningMsg('请填写正确的退货数量');
                    return;
                }
                if (_dataList[i].CanReturnCount && _dataList[i].ReturnCount > _dataList[i].CanReturnCount) {
                    this.$util.warningMsg('可退货数量不足');
                    return;
                }
                if (this.isRemarkShow && this.isForceRemark && !_dataList[i].Remark) {
                    this.$util.warningMsg('请填写备注');
                    return;
                }
            }
            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            this.dataList.push({
                EntpTempGoodsId: '',
                PurchaseQuantity: 0,
                CanReturnCount: 0,
                ReturnCount: 0,
                PurchasePrice: 0,
                WasteCount: 0,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Unit: '',
                State: 0,
                WarehousedCount: 0,
                Brand: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('elx-table--body-wrapper')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'sapcode' && !isNew) {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'countRef') {
                setTimeout(() => {
                    this.$refs[`countRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },

        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            this.$nextTick(() => {
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },

        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$set(this.submitData, 'returnMoney', this.returnMoney);
            this.$set(this.submitData, 'refundAmount', this.refundAmount);
            this.$set(this.submitData, 'orderCode', this.orderCode);
            this.$set(this.submitData, 'returnCode', this.returnCode);
            this.$set(this.submitData, 'IsDelivery', this.IsDelivery);
            this.$set(this.submitData, 'IsPartDelivery', this.IsPartDelivery);
            this.$set(this.submitData, 'EntpCusName', this.entpCusName);
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace() {
            return new Promise(resolve => {
                let data = this.$util.getLocalStorage(this.submitStorageName);
                let datalist = this.$util.getLocalStorage(this.dataStorageName);
                let that = this;
                if (data) {
                    let i = that.customerList.findIndex(item => {
                        if (item.EntpCusId == data.EntpCusId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.customerList.push({
                            EntpCusId: data.EntpCusId,
                            EntpCusName: data.EntpCusName
                        });
                        that.entpCusName = data.EntpCusName;
                    }

                    if (data.WarehouseId) {
                        let iw = that.warehouseList.findIndex(item => {
                            if (item.WarehouseId == data.WarehouseId) {
                                return true;
                            }
                        });
                        if (iw == -1) {
                            that.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }
                    }
                    let ip = that.payWayList.findIndex(item => {
                        if (item.Value == data.PayType) {
                            return true;
                        }
                    });
                    if (ip == -1) {
                        that.payWayList.push({
                            Value: data.PayType,
                            Text: data.PayTypeName
                        });
                    }
                    if (data.OrderSId) {
                        that.SIdList.push({
                            EmployeeId: data.OrderSId,
                            EmployeeName: data.OrderSName
                        });
                    }
                    if (that.isOrgShow && data.OrgId) {
                        if (!that.orgList.find(item => item.Id == data.OrgId)) that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }

                    that.submitData = data;
                    that.returnMoney = data.returnMoney;
                    that.refundAmount = data.refundAmount;
                    that.returnCode = data.returnCode;
                    that.orderCode = data.orderCode;
                    that.IsDelivery = data.IsDelivery;
                    that.IsPartDelivery = data.IsPartDelivery;
                    if(that.type==4&&data.IsDelivery){
                        that.dataReadonly = true;
                    } 
                }

                if (datalist && datalist.length > 0) {
                    that.dataList = datalist;
                }
                that.priceChange(false);
                this.startAddChace = true;
                resolve();
            });
        },
        /**
         * 从缓存中获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * WarehouseAddr 收货地址
         * WarehouseId 仓库ID
         * WarehouseName 仓库名称
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '1'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.submitData.ShipType = data.ShipType;
                        this.submitData.PayType = data.PayType;
                    }
                });
        },
        // 搜索供应商，分页
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
                //修改客户时要更新页面上展现的名称
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.submitData.EntpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        // 获取地址
        getAddressList() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAddressList',
                    data: {
                        Page: 1,
                        Limit: 999,
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) {
                        this.addressList = [];
                        return;
                    }
                    let _addressList = [];
                    for (let i = 0; i < data.length; i++) {
                        _addressList.push({
                            Text: `${data[i].Province}${data[i].City}${data[i].District}${data[i].Addr}`,
                            Value: data[i].Id
                        });
                    }
                    this.addressList = _addressList;
                });
        },
        searchCode(key, item, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder_WasteCount',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.selectLoading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索名称
        searchName(key) {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择供应商');
                return;
            }
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.selectLoading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpPurReturnOrder/GetGoodsListBySupplier',
                    data: {
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit,
                        OrderId: this.submitData.EntpCusPOId,
                        CusId: this.submitData.EntpCusId,
                        SelectedIds: []
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.selectLoading = false;
                    if (!res.data) {
                        this.$util.warningMsg('已无可退货的商品了');
                        return;
                    }
                    this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key, item) {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择供应商');
                return;
            }
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.selectLoading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpPurReturnOrder/GetGoodsListBySupplier',
                    data: {
                        SeriesName: this.autoSerieForm.key,
                        Page: this.autoSerieForm.Page,
                        Limit: this.autoSerieForm.Limit,
                        OrderId: this.submitData.EntpCusPOId,
                        CusId: this.submitData.EntpCusId,
                        SelectedIds: []
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.selectLoading = false;
                    if (!res.data) {
                        this.$util.warningMsg('已无可退货的商品了');
                        return;
                    }
                    this.autoSerieForm.stopLoad = res.data.length < this.autoSerieForm.Limit;
                    this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);
                });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        // 名称改变
        nameChange(item, index) {
            if (!this.dataList[index].APCode) {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
            }
            this.dataList[index].CanReturnCount = item.CanReturnCount;
            this.dataList[index].GoodName = item.GoodName;
            this.dataList[index].Unit = item.Unit;
            this.dataList[index].AutoSerise = item.AutoSerise;
            this.dataList[index].AutoSeriseItem = item.AutoSerise;
            this.dataList[index].PurchasePrice = item.PurchasePrice;
            this.dataList[index].PurchaseQuantity = item.PurchaseQuantity;
            this.dataList[index].ReturnCount = item.ReturnCount ? item.ReturnCount : 1;
            this.dataList[index].WasteCount = item.WasteCount;
            this.dataList[index].LatestPurchTime = item.LatestPurchTime;
            this.dataList[index].Brand = item.Brand;
            this.$nextTick(() => {
                this.priceChange();
            });
        },
        // 编码改变
        codeChange(value, index) {
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EntpTempGoodsId == value) {
                    let item = _list[i];
                    this.dataList[index].APCode = item.APCode;
                    this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                    this.dataList[index].State = 0;
                    this.dataList[index].CanReturnCount = item.CanReturnCount;
                    this.dataList[index].GoodName = item.GoodName;
                    this.dataList[index].Unit = item.Unit;
                    this.dataList[index].AutoSerise = item.AutoSerise;
                    this.dataList[index].AutoSeriseItem = item.AutoSerise;
                    this.dataList[index].PurchasePrice = item.PurchasePrice;
                    this.dataList[index].PurchaseQuantity = item.PurchaseQuantity;
                    this.dataList[index].ReturnCount = item.ReturnCount ? item.ReturnCount : 1;
                    this.dataList[index].CanReturnCount = item.CanReturnCount;
                    this.dataList[index].WasteCount = item.WasteCount;
                    this.dataList[index].LatestPurchTime = item.LatestPurchTime;
                    this.dataList[index].Brand = item.Brand;
                    break;
                }
            }
            this.$nextTick(() => {
                this.priceChange();
            });
        },
        //车型改变  AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].GoodNameItem = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Price = item.CostPrice;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].State = 0;

                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].LatestPurchTime = item.LatestPurchTime;
                this.dataList[index].Brand = item.Brand;
                this.$nextTick(() => {
                    this.priceChange();
                });
            }
        },
        // 供应商改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
                that.entpCusName = '';
            } else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                    that.entpCusName = currCust.EntpCusName;
                }
            }
            //因为需求改动以下几个赋值应该没有什么作用了，但仍然保存先 by qdl 2020/8/7
            this.submitData.Bank = '';
            this.submitData.AccountName = '';
            this.submitData.Account = '';
            this.getDefaultData();
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('', item);
            }
        },
        addressVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.addressList.length <= 1) that.getAddressList();
            }
        },
        //获取备注下拉列表
        getRemarkList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAttrs2?attrCode=pOrderReason',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.remarkList = data;
                    }
                });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;

                        if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
                        else this.canNotEditAddr = false;

                        break;
                    }
                }

                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        //采购历史
        showPurHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historyPurVisible = true;
            }
        },
        closePurHistoryDialog() {
            this.historyPurVisible = false;
        },
        //快速添加仓库地址
        addAddress() {
            this.addressDialogVisible = true;
        },
        clearAddressDialog() {
            this.$refs.addAddress.resetForm();
            this.addressDialogVisible = false;
            this.formData = {};
            this.getAddressList();
        },
        // 历史销售
        showHistoryDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historySalesVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historySalesVisible = false;
            this.historyQuoteVisible = false;
            this.historyPurVisible = false;
        },
        //历史报价
        showHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historyQuoteVisible = true;
            }
        },
        showSalesHistories(row) {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.historySalesVisible = true;
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        handleSelectionChange(val) {
            this.selectedList = [];
            if (val) this.selectedList = val;
            this.totalPriceSum();
        },
        filterAPCodeMethod({ option, row }) {
            let val = option.data.replace(/(^\s*)|(\s*$)/g, '');
            if (val) {
                val = val.toUpperCase();
            }
            return row.APCode.toUpperCase().indexOf(val) != -1;
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                switch (code) {
                    case 'GoodName':
                        that.$refs[`sapcode`].focus();
                        break;
                    case 'AutoSerise':
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'Count':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Price':
                        that.$refs[`unitSelect`].focus();
                        break;
                }
            } else if (ev.key == 'ArrowRight') {
                switch (code) {
                    case 'APCode':
                        if (that.$refs[`sapcode`]) that.$refs[`sapcode`].blur();
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'GoodName':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'AutoSerise':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`countRef`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Count':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`pirceRef`].focus();
                        break;
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 50) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        downKeyToLoad() {
            if (this.tableData && this.tableData.length > 0) {
                this.searchData.page += 1;
            } else {
                this.searchData.page = 1;
            }
            this.getAPTableData();
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }
            if (this.isBrandSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Brand';
                this.searchData.SortType = 'descending';
            }else if (this.isOriginSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Origin';
                this.searchData.SortType = 'descending';
            }
            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.WarehouseId;
            this.searchData.EntpCusId = this.submitData.EntpCusId;
            this.searchData.WarehouseId = this.submitData.WarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }
            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;
            let url = '';
            if (this.isLimitSearch) {
                url = '/api/EntpPurchaseOrder/GetGoodsjetSearshPHForR';
            } else {
                if (this.isUseSE) url = '/api/EntpGoods/GetGoodsForPurFromSE';
                else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';
            }
            this.$util
                .axiosPost({
                    url: url,
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    this.searchLoading = false;
                    let data = res.data;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }
                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadSpaceInvent = true;
                        //防止出现NaN在页面
                        if (!data[i].OrderWaitOutQuantity) {
                            data[i].OrderWaitOutQuantity = 0;
                        }
                        if (!data[i].OrderWaitOutQuantity) {
                            data[i].POrderWaitInQuantity = 0;
                        }
                    }

                    let list = [...this.tableData, ...data];
                    const maps = new Map();
                    list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                    //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;

                    let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
                    let poiqIsShow = this.isExObj('POrderWaitInQuantity');
                    let ppIsShow = this.isExObj('PlanPurchase');
                    let icIsShow = this.isExObj('IntenCount');
                    let rIsShow = this.isExObj('Remaining');
                    let sIsShow = this.isExObj('SalesOutWHCout');

                    if (owoqIsShow || poiqIsShow || ppIsShow || icIsShow || rIsShow || sIsShow) {
                        this.getOtherData(data);
                    }
                })
                .catch(e => {
                    this.searchLoading = false;
                });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(100);
                }
                //使用表格方法更新数据，因为浏览器的兼容性，某些浏览器数据更新了但是页面线上还没有边，需要点击其它地方或滚动条滚动一下才触发变化，比如留余数一列
                this.$refs.multipleTable.updateData();
            }
        },
        loopGetData(id) {
            let that = this;
            let url = '';
            if (this.isUseSE) url = '/api/EntpGoods/GetAfteSearchPartForSE';
            else url = '/api/EntpGoods/GetAfteSearchPartData_V3';
            let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
            let poiqIsShow = this.isExObj('POrderWaitInQuantity');
            let ppIsShow = this.isExObj('PlanPurchase');
            let icIsShow = this.isExObj('IntenCount');
            let sIsShow = this.isExObj('SalesOutWHCout');
            let wtIsShow = this.isExObj('WasteCount');

            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        goodsId: id,
                        sId: that.searchData.SId,
                        isShowPlanPur: ppIsShow,
                        isShowOrderWaitOut: owoqIsShow,
                        isShowPOrderWaitIn: poiqIsShow,
                        isShowInven: icIsShow,
                        isShowSalesWHCout: sIsShow,
                        isShowWasteCount: wtIsShow,
                        InStartDate: that.searchData.StartDate,
                        InEndDate: that.searchData.EndDate
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.SalesOutWHCout = data.SalesOutWHCout;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.IntenCount = data.IntenCount;
                            item.PlanPurchase = data.PlanPurchase;
                            item.SeriesCount = data.SeriesCount;
                            item.IsCommonSeries = data.IsCommonSeries;
                            if (that.isUseSE) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            ///这里查列表接口的情况下有仓库是会搜索这部分数据的，而这里接口查出的数据仅支持无仓库的情况
                            if (data.WasteCount && data.WasteCount != 0) item.WasteCount = data.WasteCount;

                            if (!that.submitData.WarehouseId) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '2',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes = [];
            this.isSearch = false;
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;
            if (!that.searchLoading) {
                that.getAPTableData();
                that.$refs.multipleTable.clearSort();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        closeSearchDialog() {
            this.isStartSearch = false;
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.dataindex = row.index;
            that.currentRow = row;
            // that.getInvenDatas(row);
        },
        // getInvenDatas(row) {
        //     let that = this;
        //     if (!row) return;
        //     that.$util
        //         .axiosGet({
        //             url: '/api/EntpGoods/GetGoodsStorageInvens',
        //             data: {
        //                 GoodsId: row.EntpTempGoodsId
        //             },
        //             hideLoading: true
        //         })
        //         .then(res => {
        //             let data = res.data;
        //             if (!data) {
        //                 return;
        //             }
        //             that.isShowSummary = true;
        //             that.summaryList = data;
        //         })
        //         .catch(() => {});
        // },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            //先获取一些数据
            if ([e][0]) {
                that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                that.$util.getGoodsDataForConfirm_V3(e.EntpTempGoodsId, '', that.submitData.EntpCusId, '2').then(data => {
                    if (data) {
                        that.rowForm = {
                            ...[e][0],
                            _price: that.type != 8 ? (data.LatestPurPrice ? data.LatestPurPrice : e.CostPrice) : e.IntenPrice,
                            _count: 1,
                            _referencePrice: data.ReferencePrice ? data.ReferencePrice : e.CostPrice
                        };
                    }
                    that.selectAutoHandle('confirm_0');
                    that.rowFormLoading = false;
                });
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                that.dataList[fIdx].ReturnCount = item._count;
                that.dataList[fIdx].PurchasePrice = item._price;
            } else {
                let newGoods = {};
                newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    ReturnCount: item._count,
                    PurchasePrice: item._price,
                    SalePrice: item.MarketPrice,
                    Unit: item.Unit,
                    Remark: '',
                    CodeRepeat: false,
                    // Inventory: item.Inventory, 去掉废品仓数量 20221012 vam
                    Inventory: item.StorageInventory,
                    WasteCount: item.WasteCount,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    LatestSalesTime: item.LatestSalesTime,
                    LatestQuoteTime: item.LatestQuoteTime,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item.CostPrice,
                    Origin: item.Origin,
                    Size: item.Size,
                    Brand: item.Brand
                };
                //移除最后一个空的配件
                if (that.dataList.length > 0 && !that.dataList[that.dataList.length - 1].EntpTempGoodsId) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                }
                that.dataList.push(newGoods);
            }
            that.priceChange();
            that.addPageChace();
            that.returnCount = 0;
            for (var j = 0; j < that.dataList.length; j++) {
                that.returnCount = parseInt(that.dataList[j].ReturnCount) + that.returnCount;
            }
            that.rowVisible = false;
            that.isStartConfirm = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        chooseAllAPsHandle() {
            let that = this;
            that.$confirm('是否将查询结果全部加入到订单商品明细中？', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        _totalCount: this.tableDataLength
                    };
                    //当查询结果出来后，用过有可能加载下一页数据，所以全部加入订单时要重置页码
                    this.searchApParams.page = 1;
                    this.loopSearch();
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            let url = '';
            if (this.isLimitSearch) {
                url = '/api/EntpPurchaseOrder/GetGoodsjetSearshPHForR';
            } else {
                if (this.isUseSE) url = '/api/EntpGoods/GetGoodsForPurFromSE';
                else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';
            }
            const { data } = await this.$util.axiosPost({
                url: url,
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);

            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.addToList(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        addToList(items) {
            let that = this;
            let itemList = [...items];
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.EntpTempGoodsId == e.EntpTempGoodsId) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.SalePrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        WasteCount: item.WasteCount,
                        ReturnCount: this.initNumber,
                        PurchasePrice: item.PurchasePrice ? item.PurchasePrice : item.Price ? item.Price : 0,
                        Unit: item.Unit,
                        Origin: item.Origin,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        LatestSalesTime: item.LatestSalesTime,
                        LatestQuoteTime: item.LatestQuoteTime,
                        State: 0,
                        canEdit: true,
                        IntenCount: item.IntenCount,
                        CostPrice: item.CostPrice,
                        BillingPrice: item.Price == 0 ? '' : item.Price,
                        Size: item.Size,
                        Brand: item.Brand
                    };
                    if (!isNaN(item._count)) {
                        newGoods.ReturnCount = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.SalePrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            that.addPageChace();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (cb) {
                this.nameCallBack = cb;
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (this.nameCallBack) {
                    this.nameCallBack(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (cb) {
                this.autoCallBack = cb;
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (this.autoCallBack) {
                    this.autoCallBack(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            if (cb) {
                this.apCodeCallBack = cb;
            }
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (this.apCodeCallBack) {
                    this.apCodeCallBack(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            if (cb) {
                this.originCallBack = cb;
            }
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (this.originCallBack) {
                    this.originCallBack(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        refreshResult() {
            this.searchData.page = 1;
            this.handleSearch();
        }
    }
};
</script>
<style lang="less" scoped>
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}
.purorder-v3 {
    padding: 10px 20px 0px 20px;
}
.el-form-item {
    margin-bottom: 0 !important;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.section-magin {
    margin-bottom: 5px;
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}

.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}

.discount-zone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-input-number {
        width: 110px;

        .el-input__inner {
            height: 32px;
        }
    }

    .el-select {
        margin-right: 12px;

        .el-input__inner {
            width: 110px;
            height: 32px;
            color: red;
        }

        .el-input__suffix {
            top: 4px;
        }

        .is-focus {
            .el-input__suffix {
                top: -4px;
            }
        }
    }
}

#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
    margin-left: 2px;
}
</style>

<style lang="less">
.el-autocomplete-suggestion {
    width: 300px !important;
}

.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}

.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;

    .popper__arrow {
        color: #303133;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.el-row {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 10px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.search-in-order {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}

.pur-order-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }

    .pur-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .purcounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .pur-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}

.mbox_ext {
    width: auto !important;
}
</style>
